import { Type as t } from '@sinclair/typebox';

export const Locale = {
  EN: 'en',
  FR: 'fr',
  ES: 'es',
  DE: 'de',
  PT: 'pt',
} as const;
export type Locale = (typeof Locale)[keyof typeof Locale];

export const LOCALES: readonly Locale[] = [Locale.EN, Locale.FR, Locale.ES, Locale.DE, Locale.PT];
export const DEFAULT_LOCALE: Locale = Locale.EN;

export const LocaleSchema = t.Union(
  [
    t.Literal(Locale.EN),
    t.Literal(Locale.FR),
    t.Literal(Locale.ES),
    t.Literal(Locale.DE),
    t.Literal(Locale.PT),
  ],
  { $id: 'Locale' },
);
